import { createSelector } from '@reduxjs/toolkit';
import { FOfferType } from '../../../../packages/JsonQuery';
import { selectOfferType } from 'shared/selectors/jsonQuery';
import { FLAT_NEW_LIST, SUBURBAN_LIST, FULL_LIST } from './constants';

export const selectConstructionTypeOptions = createSelector(selectOfferType, offerType => {
  if (offerType === FOfferType.FlatNew) {
    return FLAT_NEW_LIST;
  }

  if ((offerType & FOfferType.Suburban & ~FOfferType.Land) !== 0) {
    return SUBURBAN_LIST;
  }

  return FULL_LIST;
});
